const WidgetLoading = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-end"
      style={{ width: "100%", height: "100%" }}
    >
      <div className="skeleton w-100 h-100"></div>
    </div>
  );
};

export default WidgetLoading;
